var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/schema/fetcher";
const getObjectStores = fetcher.path("/api/object_stores").method("get").create();
export function getSelectableObjectStores() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getObjectStores({ selectable: true });
        return data;
    });
}
const getObjectStore = fetcher.path("/api/object_stores/{object_store_id}").method("get").create();
export function getObjectStoreDetails(id) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getObjectStore({ object_store_id: id });
        return data;
    });
}
